var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"ods-fade-in"}},[(_vm.visible)?_c('div',{staticClass:"ods-backtop",style:({
      'right': _vm.styleRight,
      'bottom': _vm.styleBottom
    }),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_c('ods-icon',{attrs:{"name":"chevron-up"}})]})],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }